// 页面公用组件中公用数据
const state = {
  openedSideMenu: false,
  showLoading: false,
  showShareMask: false,
  showBindPhone: false,
  showBindGameAccount: false,
  showRegisterDialog: false,
  showBindAccountDialog: false,
};

const mutations = {
  TOGGLE_SIDE_MENU: state => {
    state.openedSideMenu = !state.openedSideMenu;
  },
  CHANGE_SHOW_LOADING: (state, flag) => {
    state.showLoading = flag;
  },
  CHANGE_SHARE_MASK: (state, flag) => {
    state.showShareMask = flag;
  },
  CHANGE_BIND_PHONE: (state, flag) => {
    state.showBindPhone = flag;
  },
  CHANGE_BIND_GAME: (state, flag) => {
    state.showBindGameAccount = flag;
  },
  CHANGE_REGISTER_DIALOG: (state, flag) => {
    state.showRegisterDialog = flag;
  },
  CHANGE_BIND_ACCOUNT_DIALOG: (state, flag) => {
    state.showBindAccountDialog = flag;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
